  <div class="d-flex flex-column h-100" data-cy="collage-texteditor-container">
    <!-- https://js.devexpress.com/Documentation/19_2/ApiReference/UI_Widgets/dxHtmlEditor/Configuration/toolbar/ -->
    <dx-html-editor #editor height="620px" data-cy="collage-texteditor-editor">
      <dxo-toolbar data-cy="collage-texteditor-toolbar">
        <dxi-item name="undo" data-cy="collage-texteditor-undo"></dxi-item>
        <dxi-item name="redo" data-cy="collage-texteditor-redo"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator1"></dxi-item>
        <dxi-item name="size"
                  [acceptedValues]="['12pt', '14pt', '16pt', '18pt', '20pt', '22pt', '24pt', '26pt', '28pt','30pt', '32pt', '34pt', '36pt']" data-cy="collage-texteditor-size">
        </dxi-item>
        <dxi-item name="font"
                  [acceptedValues]="['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']" data-cy="collage-texteditor-font">
        </dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator2"></dxi-item>
        <dxi-item name="bold" data-cy="collage-texteditor-bold"></dxi-item>
        <dxi-item name="italic" data-cy="collage-texteditor-italic"></dxi-item>
        <dxi-item name="strike" data-cy="collage-texteditor-strike"></dxi-item>
        <dxi-item name="underline" data-cy="collage-texteditor-underline"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator3"></dxi-item>
        <dxi-item name="color" data-cy="collage-texteditor-color"></dxi-item>
        <dxi-item name="background" data-cy="collage-texteditor-background"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator4"></dxi-item>
        <dxi-item name="orderedList" data-cy="collage-texteditor-orderedlist"></dxi-item>
        <dxi-item name="bulletList" data-cy="collage-texteditor-bulletlist"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator5"></dxi-item>
        <dxi-item name="alignLeft" data-cy="collage-texteditor-alignleft"></dxi-item>
        <dxi-item name="alignCenter" data-cy="collage-texteditor-aligncenter"></dxi-item>
        <dxi-item name="alignRight" data-cy="collage-texteditor-alignright"></dxi-item>
        <dxi-item name="alignJustify" data-cy="collage-texteditor-alignjustify"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator6"></dxi-item>
        <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]" data-cy="collage-texteditor-header"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator7"></dxi-item>
        <dxi-item name="link" data-cy="collage-texteditor-link"></dxi-item>
        <dxi-item name="image" data-cy="collage-texteditor-image"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator8"></dxi-item>
        <dxi-item name="clear" data-cy="collage-texteditor-clear"></dxi-item>
        <dxi-item name="codeBlock" data-cy="collage-texteditor-codeblock"></dxi-item>
        <dxi-item name="blockquote" data-cy="collage-texteditor-blockquote"></dxi-item>
        <dxi-item name="separator" data-cy="collage-texteditor-separator9"></dxi-item>
      </dxo-toolbar>
      <dxo-media-resizing [enabled]="true" data-cy="collage-texteditor-mediaresizing"></dxo-media-resizing>
    </dx-html-editor>
    <div class="d-flex mt-auto" data-cy="collage-texteditor-actions">
<!--      <div class="mr-auto">-->
<!--        <dx-color-box [(value)]="backgroundColor" placeHolder="Background Color"-->
<!--                      (onValueChanged)="bgColorChanged($event)">-->
<!--        </dx-color-box>-->
<!--        <dx-color-box [(value)]="color" placeHolder="Text Color"-->
<!--                      (onValueChanged)="colorChanged($event)">-->
<!--        </dx-color-box>-->
<!--      </div>-->
      <button mat-button class="tdox-btn tdox-btn-cancel w-25 mr-2" (click)="cancel()" data-cy="collage-texteditor-cancel-button">Cancel</button>
      <button mat-button class="tdox-btn tdox-btn-primary w-25" (click)="add()" data-cy="collage-texteditor-add-button">Add</button>
    </div>
  </div>
